import z from 'zod';
import { pointGeometry, customerRef, deviceRef, assetRef, userRef, zoneRef, beaconRef, string, datetime, uuid, } from '../common';
import { asset } from './asset';
export const unresolvedBeaconScan = z.object({
    code: string,
    rssi: z.number(),
    battery: z.number().optional(),
    dateTime: datetime,
});
export const resolvedBeaconScan = z.object({
    ...unresolvedBeaconScan.shape,
    beacon: beaconRef.nullable(),
    calc: z.number().nullable(),
    valid: z.boolean(),
});
export const observationResolution = z.object({
    start: datetime,
    end: datetime,
    value: z.number().optional(),
});
export const observationResolutionDeltasSteps = z.object({
    gps: observationResolution.optional(),
    ips: observationResolution.optional(),
    context: observationResolution.optional(),
});
export const observationResolutionDeltas = z.object({
    main: observationResolution,
    steps: observationResolutionDeltasSteps.optional(),
});
export const observationMetaKnnResult = z.object({
    distance: z.number(),
    debugInfo: z.any().optional(),
});
export const observationMetaData = z.object({
    asset: asset.optional(),
    battery: z.number().optional(),
    rssi: z.number().optional(),
    snr: z.number().optional(),
    // @todo: remove dateTime and use only deviceDateTime from types
    // https://zube.io/x-guard-bv/x-guard-alarm-cloud/c/11641
    dateTime: datetime.optional(),
    deviceDateTime: datetime.optional(),
    gatewayDateTime: datetime.optional(),
    insideGpsZones: zoneRef.array().optional(),
    insideIpsZones: zoneRef.array().optional(),
    zone: zoneRef.optional(),
    callRequest: z.boolean().optional(),
    forceLoraCustomer: customerRef.optional(),
    knnResult: observationMetaKnnResult.optional(),
    // Switch availability
    available: z.boolean().optional(),
});
export const validPosition = z.object({
    value: z.boolean(),
    reason: string.optional(),
});
export const observation = z.object({
    _id: uuid,
    event: string,
    asset: asset.merge(assetRef),
    customer: customerRef,
    device: deviceRef,
    user: userRef,
    position: pointGeometry.optional(),
    beacons: z.union([
        resolvedBeaconScan.array(),
        unresolvedBeaconScan.array(),
    ]).optional(),
    meta: observationMetaData.optional(),
    deltas: observationResolutionDeltas.optional(),
    validPosition: validPosition.optional(),
    isSystemEvent: z.boolean().optional(),
});
export const observationStepKey = z.enum(['gps', 'ips', 'context']);
export const observationStepCallbackPayload = z.object({
    from: observationStepKey,
    id: uuid,
});
